// Utils
import {
  SitemapRegionsListBedAndBreakfastQuery,
  SitemapRegionsListBedAndBreakfastDocument,
} from '@gql';
import { createApolloClient } from '@utils/apollo-node-client';

export const imperativeNodeSitemapRegionsListBedAndBreakfastQuery = async (
  page: number,
  pageSize: number
) => {
  const apolloClient = createApolloClient();
  const result =
    await apolloClient.query<SitemapRegionsListBedAndBreakfastQuery>({
      query: SitemapRegionsListBedAndBreakfastDocument,
      variables: {
        page: page,
        pageSize: pageSize,
      },
    });

  return { ...result };
};
